import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Contact", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm italic" }, "Please provide your contact information for this booking.", -1)
const _hoisted_4 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4" }

import { computed, reactive } from "vue";
import _ from "lodash";
import { Guest } from "api/_lib/types";

import InputField from "@/components/elements/InputField.vue";
import SelectCountries from "./SelectCountries.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingContact',
  emits: ["update"],
  setup(__props, { emit }) {



const guest: Partial<Guest> = reactive({});

const updateContact = (field: keyof Guest, value: any) => {
  if (field && value) {
    guest[field] = value;
    emit("update", guest);
    // console.log(value)
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(InputField, {
          field: "firstName",
          label: "First Name",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (updateContact('firstName', $event)))
        }),
        _createVNode(InputField, {
          field: "lastName",
          label: "Last Name",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (updateContact('lastName', $event)))
        }),
        _createVNode(InputField, {
          field: "email",
          label: "Email",
          type: "email",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (updateContact('email', $event)))
        }),
        _createVNode(InputField, {
          field: "phone",
          label: "Phone",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (updateContact('phone', $event)))
        }),
        _createVNode(SelectCountries, {
          onChange: _cache[4] || (_cache[4] = ($event: any) => (updateContact('country', $event)))
        })
      ])
    ])
  ]))
}
}

})